























import {
  genPostReq
} from "@/services/checklist.service";

export default  {
  data () {
    return {
      initLoaded: true
    }
  },
  computed: {
    inspections() {
      return this.$store.state.che_inspections; 
    }
  },
  components: {
  
  },
  methods: {
    openInspection(item) {
      this.$router.push({ name: 'inspection', params: { uid: item.id } })
    },   
  },
  mounted() {
    this.$store.state.headerTitle = "Inspektionen"

    genPostReq('inspect-editor', 'all-inspections', { projectId: this.$store.state.che_projectId }).then( resp => {
      this.initLoaded = false
      this.$store.state.che_inspections = resp.data
    }).catch( e => {
      //this.$store.dispatch('api_error', e)
    });
  },
   created () {
     
  }
}

